export default class FormOpener {

  constructor(){
    this.panel = document.querySelector('.leadform__fields');
    this.togglers = this.panel.querySelectorAll('input');
    this.closedClass = 'leadform__fields--closed';
    this.togglers.forEach((elem, index) => {
      elem.addEventListener('focus', ()=>{
        this.togglePanel();
      });
    });
  }

  togglePanel(){
    let isClosed = this.panel.classList.contains(this.closedClass);
    if(isClosed) {
      this.panel.classList.remove(this.closedClass);
    }
  }

}
